import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SrQuestionMark from 'client/components/SrQuestionMark';
import SrContactModal from 'client/components/SrContactModal';
import branch from 'client/core/branch';

@branch({
  userAssignedCustomerSupportPhone: ['currentUser', 'customerSupportPhone'],
})
class SrContactUsButton extends Component {
  static propTypes = {
    userAssignedCustomerSupportPhone: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      showContactModal: false,
    };
  }

  _onQuestionMarkClick = (e) => {
    e.preventDefault();
    this.setState({
      showContactModal: true,
    });
  };

  _onCloseContactModal = () => {
    this.setState({
      showContactModal: false,
    });
  };

  render() {
    const { userAssignedCustomerSupportPhone } = this.props;
    const { showContactModal } = this.state;
    return (
      <div className="SrContactUsButton">
        <SrQuestionMark onClick={this._onQuestionMarkClick} />
        <SrContactModal
          isOpen={showContactModal}
          onClose={this._onCloseContactModal}
          onClickMessage={null}
          onClickCall={null}
          url={null}
          phoneNumber={userAssignedCustomerSupportPhone}
        />
      </div>
    );
  }
}

SrContactUsButton.displayName = 'SrContactUsButton';

export default SrContactUsButton;
